module.exports = __webpack_public_path__ + "img/20.764aa63a.webp";